import wixLocationFrontend from "wix-location-frontend";
import { session } from 'wix-storage';

export function handleParam(paramKey, setParamInSessionMethod, additionalParams) {
    const parsedUrl = new URL(wixLocationFrontend.url);
    const paramFromUrl = parsedUrl.searchParams.get(paramKey);
    const paramFromSession = session.getItem(paramKey);

    if (paramFromUrl && paramFromSession) {
        return;
    }
    
    if (!paramFromUrl && !paramFromSession) {
        return;
    }

    if (paramFromUrl && !paramFromSession) {
        setParamInSessionMethod(paramKey, paramFromUrl); 
        return;
    }

    if (!paramFromUrl && paramFromSession) {
        wixLocationFrontend.queryParams.add({
            ...additionalParams,
            [paramKey]: paramFromSession,
        });

        const urlWithParams = wixLocationFrontend.url;
        wixLocationFrontend.to(urlWithParams);
        return;
    }
}

export function setParamInSession(paramKey, paramFromUrl){
    session.setItem(paramKey, paramFromUrl);
    console.log(`${paramKey} saved to session storage:`, paramFromUrl);
}